export default __webpack_public_path__ + "static/media/alex_xl.26b8ff1b.jpg";